module.exports = __webpack_public_path__ + "media/application/images/icons/thumbdown-outline-4752b3b6cb7fe31ec5f723fcab790fe6.svg";